/* eslint-disable @typescript-eslint/no-magic-numbers */
export enum AppConfigKeys {
  APP_ENV = 'APP_ENV',
}

export enum EScriptEnv {
  DEV = 'dev',
  INT = 'int',
  LOCAL = 'local',
  PROD = 'prod',
  TEST = 'test',
}

export enum ECompleteEnv {
  DEV = 'development',
  INT = 'integration',
  LOCAL = 'local',
  PROD = 'production',
  TEST = 'test',
}

export type CompleteToScriptEnvMapping = {
  [key in ECompleteEnv]: EScriptEnv;
};

export const SESSION_LENGTH_MAP: Record<EScriptEnv, number> = {
  [EScriptEnv.DEV]: 30 * 60, // 30 minutes in seconds
  [EScriptEnv.INT]: 30 * 60,
  [EScriptEnv.LOCAL]: 30 * 60,
  [EScriptEnv.PROD]: 30 * 60,
  [EScriptEnv.TEST]: 5, // 5 seconds for testing
};

// TODO: remove this once we have a proper way to handle market filtering
export const MARKET_FILTERING_ENABLED =
  process.env['VITE_APP_MARKET_FILTERING_ENABLED'] === 'true';
